//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "audiolist",
  data(){
      return{
        list:[]
      }
  },
  created() {
      this.axios.post('/xcx/Order/audioList',{cate_id:this.$route.query.id}).then(res=>{
        this.list=res.data.data;
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/audiolist/audiolist.vue